<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-button style="padding: 0; margin: 20px" type="text" icon="el-icon-back" @click="$router.go(-1)">
                    返回
                </el-button>
            </el-col>
        </el-row>

        <el-form :model="meetStoryInfo" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="标题" prop="title">
                <el-input v-model="meetStoryInfo.title" maxlength="30" show-word-limit style="width:33%"></el-input>
            </el-form-item>
            <el-form-item label="分类" prop="category_id">
                <el-select v-model="meetStoryInfo.category_id" placeholder="请选择分类" style="width:33%">
                    <el-option
                        v-for="item in meetStoryCategory"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="图片">
                <el-upload class="avatar-uploader" :action="ossAction" :show-file-list="false" :http-request="uploadOSSRequest"
                           :before-upload="beforeImageUpload">
                    <img v-if="meetStoryInfo.img_url" :src="meetStoryInfo.img_url" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="el-upload__tip">
                        只能上传jpg/png文件，且不超过500kb
                    </div>
                </el-upload>
            </el-form-item>

            <el-form-item label="学习人数" prop="number">
                <el-input v-model="meetStoryInfo.study_number" style="width:33%"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
                <el-input v-model="meetStoryInfo.sort" style="width:33%"></el-input>
            </el-form-item>
            <el-form-item label="点赞数" prop="sort">
                <el-input size="mini" v-model="meetStoryInfo.virtual_like_number" @input="validateInput" autocomplete="off" style="width:33%"></el-input>
            </el-form-item>
            <el-form-item label="转发数" prop="sort">
                <el-input size="mini" v-model="meetStoryInfo.virtual_relay_number" @input="validateInput2" autocomplete="off" style="width:33%"></el-input>
            </el-form-item>
            <el-form-item label="详情">
                <tinymce v-model="meetStoryInfo.content" style="width:66%"></tinymce>
            </el-form-item>

            <el-form-item v-if="meetStoryInfo.category == 2" label="副标题">
                <el-input v-model="meetStoryInfo.subtitle" style="width:33%"></el-input>
            </el-form-item>
            <el-form-item v-if="meetStoryInfo.category == 2" label="上课地点">
                <el-input v-model="meetStoryInfo.class_address" style="width:33%"></el-input>
            </el-form-item>
            <el-form-item v-if="meetStoryInfo.category == 2" label="上课日期">
                <el-date-picker v-model="meetStoryInfo.start_at" type="date" value-format="yyyy-MM-dd" placeholder="选择开始时间">
                </el-date-picker>~
                <el-date-picker v-model="meetStoryInfo.end_at" type="date" value-format="yyyy-MM-dd" placeholder="选择结束时间">
                </el-date-picker>
            </el-form-item>

            <el-form-item>
                <el-button size="small" type="primary" @click="
            createUpdateMeetStory()
          " :loading="updateLoading">确 定</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
import tinymce from "@/components/tinymce.vue";

import {
    beforeImageUpload,
    uploadOSSRequest,
    getAliyunOssToken,
} from "@/api/common";

import { createUpdateMeetStory, getMeetStoryInfo, getAllMeetStoryCategory } from "@/api/story";

export default {
    data: function () {
        return {
            isshow: false,
            ossAction: "",
            ossData: {},
            loading: false,
            aliyunOssToken: "",
            updateLoading: false,
            editor: null,
            meetStoryInfo: {
                id: 0,
                category: this.$route.query.category,
                title: "",
                img_url: "",
                content: "",
                study_number: 0,
                sort: 0,
                category_id: null,

                subtitle: "",
                class_address: "",
                start_at: "",
                end_at: "",
                virtual_like_number: 0,
                virtual_relay_number: 0,
            },
            meetStoryCategory: [],
            categoryType:{
                type:1,
            }
        };
    },
    components: {
        tinymce,
    },
    created: function () {
        this.getAllMeetStoryCategory()
        this.meetStoryInfo.id = this.$route.query.id;
        if (this.meetStoryInfo.id > 0) {
            this.getInfo();
        }
    },
    mounted() {},
    computed: {},
    methods: {
        validateInput(event) {
            console.log(event);

            let value = event;
            // 移除非数字字符
            value = value.replace(/\D/g, "");
            // 检查第一个字符是否为0
            if (value.length > 0 && value[0] === "0") {
                value = value.substring(1);
            }
            this.meetStoryInfo.virtual_like_number = value;
        },
        validateInput2(event) {
            console.log(event);

            let value = event;
            // 移除非数字字符
            value = value.replace(/\D/g, "");
            // 检查第一个字符是否为0
            if (value.length > 0 && value[0] === "0") {
                value = value.substring(1);
            }
            this.meetStoryInfo.virtual_relay_number = value;
        },
        beforeImageUpload(file) {
            beforeImageUpload(file);
        },
        uploadOSSRequest(file) {
            getAliyunOssToken({ dir: "" }).then((res) => {
                uploadOSSRequest(file.file, res.data).then((fileUrl) => {
                    this.meetStoryInfo.img_url = fileUrl;
                });
            });
        },

        getInfo() {
            this.loading = true;
            getMeetStoryInfo({
                id: this.meetStoryInfo.id,
            }).then((response) => {
                this.meetStoryInfo = response.data;
                this.loading = false;
            });
        },
        createUpdateMeetStory() {
            if (!this.meetStoryInfo.category_id) {
                this.$message({
                    message: "请选择分类",
                    type: "error",
                });
            }
            this.updateLoading = true;
            createUpdateMeetStory(this.meetStoryInfo)
                .then((response) => {
                    this.updateLoading = false;
                    if (response.code == 1) {
                        this.$message.success(response.message);
                        this.$router.push({
                            path: "/story/meetStoryList",
                            query: {
                                category: this.$route.query.category,
                            },
                        });
                    }
                })
                .catch((err) => {
                    this.updateLoading = false;
                });
        },

        ref() {
            window.history.go(-1);
        },
        getAllMeetStoryCategory() {
            // this.loading = true;
            getAllMeetStoryCategory(this.categoryType).then((response) => {
                this.meetStoryCategory = response.data;
                // this.loading = false;
            });
        },
    },
};
</script>
<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.hides {
    background: #fff;
    width: 100px;
    height: 100px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    text-align: center;
}
</style>